// Lightweight modal open/close with a 200ms transition, mirroring Vouched.
// A modal is `hidden` by default; opening adds `flex` then (next frame)
// `modal-visible` to trigger the CSS opacity/scale transition. Closing reverses
// it and re-hides after the transition completes.
function openModal(id) {
  const m = document.getElementById(id)
  if (!m) return
  m.classList.remove("hidden")
  m.classList.add("flex")
  requestAnimationFrame(() => m.classList.add("modal-visible"))
}

function closeModal(id) {
  const m = document.getElementById(id)
  if (!m) return
  m.classList.remove("modal-visible")
  setTimeout(() => {
    m.classList.add("hidden")
    m.classList.remove("flex")
  }, 200)
}

window.openLogoutModal = function () { openModal("logout-modal") }
window.closeLogoutModal = function () { closeModal("logout-modal") }

// Generic helpers so any modal (e.g. the dev user switcher) can open/close by id.
window.openModal = openModal
window.closeModal = closeModal
